export const getGender = (gender?: number) => {
  return undefined !== gender ? (gender === 0 ? 'female' : 'male') : ''
}
